export const TRACKING_SOURCE = "ZORNI_PORTAL";

export const ContextPage = Object.freeze({
  HOME: "HOME",
  TRIPS_LIST: "TRIPS_LIST",
  PUBLICATION_DETAILS: "PUBLICATION_DETAILS",
  BOOKING: "BOOKING",
});

export const Category = Object.freeze({
  VISIBILITY_EVENT: "VISIBILITY_EVENT",
  CONVERSION_EVENT: "CONVERSION_EVENT",
  MARKETING_EVENT: "MARKETING_EVENT",
  TECHNICAL_EVENT: "TECHNICAL_EVENT",
});

export const EventType = Object.freeze({
  SEARCH_IMPRESSION: "SEARCH_IMPRESSION",
  PUBLICATION_VIEW: "PUBLICATION_VIEW",
  PREVIEW_VIEW: "PREVIEW_VIEW",
  CLICK_BOOKING_BUTTON: "CLICK_BOOKING_BUTTON",
  ADD_TO_FAVORITES: "ADD_TO_FAVORITES",
  TIME_SPENT_ON_PUBLICATION: "TIME_SPENT_ON_PUBLICATION",
  BOUNCE_EVENT: "BOUNCE_EVENT",
  REVIEW_READ: "REVIEW_READ",
});
